<template>
  <div>
    <div class="columns is-vcentered is-border-bottom has-bg-light">
      <div class="column is-size-6">
        {{companies.length}} Société(s)
      </div>
      <div v-if="isAdmin" class="column is-narrow">
        <a @click="newCompany" class="has-text-grey is-uppercase is-size-6">
          <span class="icon"><i class="fal fa-plus"></i></span>
          <span>Ajouter une société</span>
        </a>
      </div>
    </div>
    <table
      class="table is-fullwidth is-last-fixed-small is-marginless-bottom is-radius-bottom-left is-radius-bottom-right"
      v-if="companies && companies.length">
      <thead>
      <tr class="is-size-6">
        <th>Nom</th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(company, i) in companies" :key="company.company" class="is-size-6">
        <td class="is-cell-hoverable">
          <router-link :to="{name: 'CompanyVue', params: {id: company.company}}" class="fullLink" v-if="company.company">
            <avatar :item="company" :i="i" class="is-margin-right-xsmall"></avatar>
            <span>{{company.name}}</span>
          </router-link>
          <span v-else>{{company.name}}</span>
        </td>
        <td class="actions has-text-right">
          <display-button-list :buttons="buttonList" :data="company"
              :openUp="{'position': i, 'total': companies.length}">
          </display-button-list>
          <!-- <a @click="deleteSeller(s)" class="button is-circle is-white is-small"
             :class="{'disabled': s._removed }">
            <i class="fal fa-trash"></i>
          </a> -->
          <!-- <a @click="updateSeller(s)" class="button is-circle is-white is-small"
             :class="{'disabled': s._removed }">
            <i class=" fas fa-edit"></i>
          </a> -->
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  import { mapGetters, mapState } from 'vuex'
  import { StatsMx } from '@/mixins'
  import moment from 'moment'

  export default {
    name: 'UserSectorList',
    mixins: [StatsMx],
    data () {
      return {
        buttonList: [
          {
            action: (id, data) => {
              this.deleteCompany(data)
            },
            icon: 'fas fa-user-minus',
            text: 'Retirer du manager',
            needProfile: ['admin', 'manager']
          }
        ],
        sellerModel: [],
        companies: [],
        toRemove: [],
        isAdding: false
      }
    },
    props: {
      sourceCompanies: {
        type: Array,
        required: true
      },
      sourceUser: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapState(['quickview']),
      ...mapGetters(['isExternal', 'isAdmin']),
      currentUser () {
        return this.sourceUser
      },
      userCompanyPk () {
        return this.currentUser.company ? this.currentUser.company.pk || this.currentUser.company : null
      },
      currentYear () {
        return moment().format('YYYY')
      }
    },
    watch: {
      quickview ({mode, params, results}) {
        if (results) {
          if (mode === 'ENTITY_SELECTION') {
            this.addCompany(results.entities)
          }
        }
      }
    },
    methods: {
      async addCompany (results) {
        let companies = results.map(x => x.pk)
        let params = {
          companies
        }
        try {
          let { data } = await this.$api.axios.post(`users/${this.sourceUser.pk}/companies`, params)
          this.$emit('addCompanies')
          for (let company of data) {
            this.companies.unshift(company)
          }
          this.$notify({
            type: 'is-success',
            text: 'Companie(s) ajoutée(s) au manager.'
          })
        } catch (err) {
          console.log(err)
          this.$notify({
            type: 'is-danger',
            text: 'Impossible d\'ajouter cette(ces) companie(s) à ce manager.'
          })
        }
      },
      async deleteCompany (company) {
        try {
          await this.$api.axios.delete(`users/${this.sourceUser.pk}/companies/${company.company}`)
          this.$emit('deleteCompanies')
          let index = this.companies.findIndex(x => x.company === company.company)
          this.companies.splice(index, 1)
          this.$notify({
            type: 'is-success',
            text: 'Companie retirée du manager.'
          })
        } catch (err) {
          console.log(err)
          this.$notify({
            type: 'is-danger',
            text: 'Impossible de retirer cette companie à ce manager.'
          })
        }
      },
      newCompany () {
        let excludes = this.companies.map(x => x.company)
        console.log(excludes)
        let params = {
          mode: 'append',
          customAlgoliaKey: 'COMPANY',
          excludes
        }
        this.$store.commit('setQuickview', { mode: 'ENTITY_SELECTION', params })
      }
    },
    created () {
      this.companies = this.sourceCompanies.slice()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/UserVuePanel/UserSectorList.vue